<template>
  <div class="flex-center position-ref">
    <div class="content">
      <Loading :loading="loading"></Loading>
      <SsoError v-if="error" :message="error"></SsoError>

      <div v-if="this.bookCodeDiv || this.onlineCodeDiv" style="margin: 0 0 20px 0">
        <img src="/assets/images/richmond-logo.png" style="height: 50px;">
      </div>

      <div v-else>
        <img src="/assets/logos/richmond-studio.png">
        <h3 v-if="this.$route.query.sso && !error">Lütfen bekleyiniz, ilgili platforma yönlendiriliyorsunuz.</h3>
      </div>

      <div v-if="this.onlineCodeDiv" style="background-color: #efefef; padding: 20px; text-align: left; width: 750px; line-height: 24px;">
        <h3>Richmond Studio Aktivasyon Adımları</h3>
        <div>
          <strong style="color:#f00;">1.</strong> Platforma ilk defa erişiyorsanız, öncelikle aşağıdaki <strong>"Kodu Kopyala"</strong> butonuna basarak kitap kodunuzu kopyalayınız.<br />
          <strong style="color:#f00;">2.</strong> Altta gördüğünüz <strong>"Richmond Studio"</strong> simgesine tıklayınız ve siteye geçiş yapınız.<br />
          <strong style="color:#f00;">3.</strong> Açılan ekranda <strong>"MY PRODUCTS"</strong> başlığı altında bulunan <strong>"NEW PRODUCT"</strong> butonuna basın ve kopyaladığınız kodu <strong>"Please Enter a Code"</strong> alanına yazınız.<br />
          <strong style="color:#f00;">4.</strong> Kodu yapıştırdıktan sonra alt bölümde yer alan <strong>"Add Product"</strong> butonuna tıklayınız.<br />
          <strong style="color:#f00;">5.</strong> Ardından ekranda göreceğiniz <strong>"START"</strong> butonuna tıklayınız.<br />
          <strong style="color:#f00;">6.</strong> Artık hesabınızda kitabınız aktif edilmiştir. Platformu kullanmaya başlayabilirsiniz.<br />
          <strong style="color:#f00;">7.</strong> Sonraki erişimlerinizde sadece <strong>"Richmond Studio"</strong> simgesine basıp platformu kullanabilirsiniz.<br />
        </div>
        <div style="margin: 20px auto; width:400px; padding: 10px; background-color: #bcf1b6; align-items: center; text-align: center;">
          <strong style="margin-right:10px;">{{ this.userData.class_richmond_code }}</strong>
          <button type="button" class="code-copy-button" @click.prevent="copyCode">Kodu Kopyala</button>
        </div>
        <table style="width: 100%;">
          <tr>
            <td style="width: 50%; text-align: center;">
              <a href="#/go_richmondstudio" @click.prevent="goRichmondStudioSso()">
                <img src="/assets/logos/richmond-studio.png">
              </a>
            </td>
            <!--
            <td style="width: 50%; text-align: center;">
              <a href="https://www.youtube.com/embed/5VS7u30m_Gc?si=2K_RXLa5Y_u_L64y" target="_blank">
                <img src="/assets/images/youtube.jpg" style="width:300px;">
              </a>
            </td>
            -->
          </tr>
        </table>
      </div>

      <br /><br />

      <div v-if="this.bookCodeDiv" style="background-color: #efefef; padding: 20px; text-align: left; width: 750px; line-height: 24px;">
        <h3>Richmond Studio Aktivasyon Adımları</h3>
        <div>
          <strong style="color:#f00;">1.</strong> Platforma ilk defa erişiyorsanız altta gördüğünüz <strong>"Richmond Studio"</strong> simgesine tıklayınız ve siteye geçiş yapınız.<br />
          <strong style="color:#f00;">2.</strong> Açılan ekranda <strong>"MY PRODUCTS"</strong> başlığı altında bulunan <strong>"NEW PRODUCT"</strong> butonuna basın ve kitabınızda ön kapak içinde bulunan kodu <strong>"Please Enter a Code"</strong> alanına yazınız.<br />
          <strong style="color:#f00;">3.</strong> Kodu yazdıktan sonra alt bölümde yer alan <strong>"Add Product"</strong> butonuna tıklayınız.<br />
          <strong style="color:#f00;">4.</strong> Ardından ekranda göreceğiniz <strong>"START"</strong> butonuna tıklayınız.<br />
          <strong style="color:#f00;">5.</strong> Artık hesabınızda kitabınız aktif edilmiştir. Platformu kullanmaya başlayabilirsiniz.<br />
          <strong style="color:#f00;">6.</strong> Sonraki erişimlerinizde sadece <strong>"Richmond Studio"</strong> simgesine basıp platformu kullanabilirsiniz.<br />
        </div>
        <br />
        <table style="width: 100%;">
          <tr>
            <td style="width: 50%; text-align: center;">
              <a href="#/go_richmondstudio" @click.prevent="goRichmondStudioSso()">
                <img src="/assets/logos/richmond-studio.png">
              </a>
            </td>
            <!--
            <td style="width: 50%; text-align: center;">
              <a href="https://www.youtube.com/embed/O2x4o_LeEqY?si=ctl_x10KvOEDzTVe" target="_blank">
                <img src="/assets/images/youtube.jpg" style="width:300px;">
              </a>
            </td>
            -->
          </tr>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import SsoError from "@/components/SsoError";
import CryptoJS from 'crypto-js';
import axios from "axios";
import { isJwtSso } from "@/utils/ssoJwt";

export default {
  name: "RichmondStudio",
  components: {
    Loading,
    SsoError
  },
  data() {
    return {
      loading: false,
      secretKey: 'Ke8bg7uCBhGxC2rGpiKBfJ@CvMCTwy@gyCUxyFjV4pReKz!RdgPzisjDxPJw7-zU',
      secretKey2: 'puFNGs3uiFeRfLqdyUvDRabsCaCyptVuexMdZMUgtxiuyQuNuzw7mMYGig7X3ncU', // RichmondStudio servisine giderken
      userData: null,
      ssoJwt: null,
      onlineCodeDiv: false,
      bookCodeDiv: false,
      error: null,
    }
  },
  beforeMount() {
    const query = this.$route.query;
    if (query.sso) {
      // Akbim altyapılı bazı okullar (ör. Şahinkaya Koleji) AES yerine kendi JWT'lerini
      // gönderiyor — bu durumda AES çözmeyi hiç denemiyoruz (denersek atob() "." karakteri
      // yüzünden hata verir), ham değeri sso_jwt olarak backend'e yolluyoruz; okul/kampüs
      // eşleştirmesi ve çözme orada yapılıyor (bkz. AkbimJwtSsoService).
      if (isJwtSso(query.sso)) {
        this.ssoJwt = query.sso;
        this.ueslmsCheckUser();
        return;
      }

      const decode = decodeURIComponent(atob(query.sso));
      const bytes = CryptoJS.AES.decrypt(decode, this.secretKey).toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(bytes);
      this.ueslmsCheckUser()
    }
  },
  methods: {
    fail(message) {
      this.loading = false;
      this.error = message;
      console.log('RichmondStudio SSO:', message);
    },

    ueslmsCheckUser() {
      // console.log('RichmondStudio userData', this.userData);
      const body = this.ssoJwt ? {sso_jwt: this.ssoJwt} : {user: this.userData};
      axios.post('https://www.ueslms.com/api/v2/richmondstudio/user/check', body)
      // axios.post('https://ueslms.test/api/v2/richmondstudio/user/check', body)
          .then(response => {
            if (response.data.success) {
              this.userData = response.data.user;
              this.checkRichmondStudioCode()
            } else if (response.data.message) {
              this.fail(response.data.message)
            } else {
              this.ueslmsCreate()
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    ueslmsCreate() {
      const body = this.ssoJwt ? {sso_jwt: this.ssoJwt} : this.userData;
      axios.post('https://www.ueslms.com/api/v2/richmondstudio/user/create', body)
      // axios.post('https://ueslms.test/api/v2/richmondstudio/user/create', body)
          .then(response => {
            if (response.data.success) {
              this.userData = response.data.user;
              this.checkRichmondStudioCode()
            } else {
              this.fail(response.data.message || 'Kullanıcı oluşturulamadı. Lütfen tekrar deneyin.')
            }
          })
          .catch(response => {
            console.log('ERR', response)
          })
    },

    checkRichmondStudioCode() {
      // 2024-2025 sezonu için bazı okulların özel lms'de kod gösterme devreye aldığımız için
      // ilgili okullarda bu işlemi devre dışı bırakıyoruz.
      // if (
      //     // this.userData.school_id === 63    ||  // Final Okulları
      //     // this.userData.school_id === 85177 ||  // İskenderun Tek Koleji
      //     // this.userData.school_id === 85    ||  // Gundogdu Schools
      //     // this.userData.school_id === 274   ||  // Adana Erkan Koleji
      //     // this.userData.school_id === 11843 ||  // Diyarbakır Ortadoğu Koleji
      //     // this.userData.school_id === 97315 ||  // Ekin Koleji
      //     // this.userData.school_id === 97328 ||  // Malatya İntegral Okulları
      //     // this.userData.school_id === 97326 ||  // Hatay Doğuş Okulları
      //     this.userData.school_id === 11614     // Bilfen Okulları
      // )
      // {
      //   this.goRichmondStudioSso()
      // } else {
        // kampüs'te richmondstudio var ve kitabındaki kodu kullanacak
        if (this.userData.rlp_institute_code && this.userData.class_richmond_code === '###') {
          this.bookCodeDiv = true
        }
        // kampüste richmondstudio var ve online'da yazan kodu kullanacak
        else if (this.userData.rlp_institute_code && this.userData.class_richmond_code !== null) {
          this.onlineCodeDiv = true
        }
        // kampüste richmondstudio var ve direkt gidebilir
        else if (this.userData.rlp_institute_code) {
          this.goRichmondStudioSso()
        }
        // rlp_institute_code tanımlı değil. yani kampüste richmondstudio tanımlı değil.
        else {
          alert('kampuste rlp_institute_code tanimli degil')
        }
      // }
    },

    goRichmondStudioSso() {
      const removeKeys = ["class_id", "class_name", "class_richmond_code", "kurum_id", "rlp_institute_code", "school_name", "user_name"];

      const filteredData = Object.fromEntries(
          Object.entries(this.userData).filter(([key]) => !removeKeys.includes(key))
      );

      // console.log('goRichmondStudioSso', filteredData);
      const textJson = JSON.stringify(filteredData);
      const uriText = decodeURIComponent(textJson);
      const ciphertext = CryptoJS.AES.encrypt(uriText, this.secretKey2).toString();
      // console.log('ciphertext', ciphertext);
      window.location.href = "https://richmondstudio.global/ueshub/sessions/new?token=" + btoa(ciphertext);
    },

    copyCode() {
      navigator.clipboard.writeText(this.userData.class_richmond_code);
      alert('Kod kopyalandı.')
    }

  }
}
</script>

<style scoped>
.code-copy-button {
  background-color: #037148;
  border: none;
  color: white;
  padding: 6px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}

.code-copy-button:hover {
  background-color: #034e32;
}
</style>
